import { connect } from 'react-redux';
import { addFutureChanged } from '../actions';
import AddFutureItems from '../components/AddFutureItems';

const mapStateToProps = (state, { form, dimensionFilter, dataRestriction, ...rest }) => {
    const { activeMemberType } = state.teamManagement;
    let addFuture = false;

    if (dataRestriction) {
        addFuture = state.teamManagement.dataRestrictions[form]?.addFuture || false;
    } else if (dimensionFilter) {
        addFuture = state.teamManagement.dimensionFilters[form]?.addFuture || false;
    } else {
        addFuture = state.teamManagement[form]?.addFuture || false;
    }

    return {
        activeMemberType,
        addFuture,
        ...rest,
    };
};

const mapDispatchToProps = (dispatch, { form, dimensionFilter, dataRestriction }) => {
    return {
        onChange: (...args) => {
            dispatch(addFutureChanged(form, dimensionFilter, ...args, dataRestriction));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AddFutureItems);

